import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import RevisionPlanActions from 'components/tables/data/revision-plan/RevisionPlanActions';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ data }: { data: RevisionPlanRow }) {
  return <RevisionPlanActions {...data} compactOnTablet />;
}
